import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import { ErrorRounded, WarningRounded } from '@mui/icons-material';
import { softTints } from '../../constants/uiTokens';
import Txt from './Txt';

const CONFIG = {
  zero: {
    tint: softTints.error,
    icon: ErrorRounded,
    title: () => 'Você está sem créditos',
    desc: 'Nenhuma mensagem será enviada até você recarregar. Os agendamentos continuam funcionando normalmente.',
    cta: 'Comprar créditos',
  },
  low: {
    tint: softTints.warning,
    icon: WarningRounded,
    title: (b) => `Saldo baixo: ${Number(b).toLocaleString('pt-BR')} créditos`,
    desc: 'Recarregue para não interromper os envios automáticos aos seus clientes.',
    cta: 'Recarregar',
  },
};

/**
 * BalanceBanner — banner de saldo zero/baixo, traduzido do mockup. Apresentacional:
 * recebe `state` + `balance` + `onBuy`. Usado pela /integrations real E pela /design-lab
 * (fonte única, sem divergência entre tela e sandbox).
 */
export default function BalanceBanner({ state, balance = 0, onBuy, sx }) {
  const c = CONFIG[state];
  if (!c) return null;
  const Icon = c.icon;
  return (
    <Box
      sx={{
        display: 'flex', alignItems: 'center', gap: 1.75, flexWrap: 'wrap',
        bgcolor: c.tint.bg, border: '1px solid', borderColor: c.tint.border,
        borderLeft: '4px solid', borderLeftColor: c.tint.main,
        borderRadius: '8px', p: '14px 18px',
        ...sx,
      }}
    >
      <Icon sx={{ fontSize: 24, color: c.tint.main }} />
      <Box sx={{ flex: 1, minWidth: 160 }}>
        <Txt sx={{ fontSize: 14, fontWeight: 600, color: c.tint.fg }}>{c.title(balance)}</Txt>
        <Txt sx={{ fontSize: 13, color: c.tint.sub }}>{c.desc}</Txt>
      </Box>
      <Button
        onClick={onBuy}
        disableElevation
        sx={{ bgcolor: c.tint.main, color: '#fff', borderRadius: '8px', px: 2, py: 1, fontSize: 13.5, fontWeight: 600, whiteSpace: 'nowrap', '&:hover': { bgcolor: c.tint.fg } }}
      >
        {c.cta}
      </Button>
    </Box>
  );
}

BalanceBanner.propTypes = {
  state: PropTypes.oneOf(['zero', 'low']),
  balance: PropTypes.number,
  onBuy: PropTypes.func,
  sx: PropTypes.object,
};
